module.exports = __webpack_public_path__ + "static/media/publishPictures.e1222671.png";